import { render } from "./About.vue?vue&type=template&id=786fc37c"
const script = {}
script.render = render

export default script